import { TOfferContextData } from '../../../../types/offer-card';
import { getIsDailyRent } from '../../../../utils/computedProps/price/rent/getIsDailyRent';

export const getQualityLevelInfo = (offerData: TOfferContextData) => {
  return offerData.offer.user?.agentModerationInfo?.qualityLevelInfo;
};

export const getAgentLevelInfo = (offerData: TOfferContextData) => {
  if (getQualityLevelInfo(offerData)) {
    return null;
  }

  return offerData.offer.user?.agentModerationInfo?.userLevelInfo;
};

export const getIsUserIdentifiedByDocuments = (offerData: TOfferContextData) => {
  const qualityLevelInfo = getQualityLevelInfo(offerData);
  const isDailyrent = getIsDailyRent(offerData.offer.category);

  if (qualityLevelInfo) {
    const { hasVerifiedDocuments, levelOrder = 0 } = qualityLevelInfo;

    if (isDailyrent) {
      return !!hasVerifiedDocuments;
    }

    return !!hasVerifiedDocuments && levelOrder < 4;
  }

  return !!offerData.offer.user?.agentModerationInfo?.userLevelInfo?.hasVerifiedDocuments;
};

export const getQualityLevelSystemName = (offerData: TOfferContextData) => {
  const isDailyrent = getIsDailyRent(offerData.offer.category);

  if (isDailyrent) {
    return;
  }

  return offerData.offer.user?.agentModerationInfo?.qualityLevelInfo?.levelSystemName;
};
